import styled from 'styled-components';
import { Subtitle1, colors, spacing } from 'ui/theme';

export const OptionsContainer = styled.div`
  background-color: ${colors.backgroundPrimary};
  padding: ${spacing.plusHalf} ${spacing.base};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: ${spacing.double};
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
`;

export const GreyContainer = styled.div`
  background-color: ${colors.backgroundSecondary};
  padding: ${spacing.plusHalf};
  border-bottom: ${spacing.single} solid ${colors.borderPrimarySubtle};
`;

export const WarningContainer = styled.div`
  display: grid;
  gap: ${spacing.threeEights};
  grid-template-columns: auto auto;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${spacing.half};
`;

export const Heading = styled(Subtitle1)`
  margin: 0;
`;

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: ${spacing.base} ${spacing.plusHalf};
  background-color: ${colors.backgroundPrimary};
  border-top: ${spacing.single} solid ${colors.borderPrimarySubtle};
`;
